import { mainSiteUrl } from '@/mocks/categories';

export default function Hero() {
  return (
    <section id="hero" className="relative w-full h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20composition%20of%20curated%20fashion%20streetwear%20items%20including%20premium%20sneakers%20textured%20hoodies%20and%20accessories%20arranged%20on%20warm%20ivory%20linen%20surface%2C%20soft%20diffused%20natural%20window%20light%20from%20left%2C%20gentle%20shadows%2C%20editorial%20product%20photography%20style%2C%20minimalist%20Scandinavian%20aesthetic%2C%20warm%20neutral%20earth%20tones%20palette%2C%20generous%20empty%20central%20space%20for%20text%20overlay%2C%20harmonious%20balanced%20composition%20with%20organic%20flow&width=1800&height=1000&seq=hero-main-v2-jun26&orientation=landscape"
          alt="Hoobuy Spreadsheet - Produtos selecionados com estilo moderno e minimalista"
          title="Hoobuy Spreadsheet 2026 - Melhor Planilha Hoobuy"
          className="w-full h-full object-cover object-top"
        />
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full px-6 md:px-10 flex flex-col items-center text-center">
        <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white leading-tight max-w-4xl drop-shadow-[0_2px_8px_rgba(0,0,0,0.3)]">
          Melhor Hoobuy Spreadsheet
          <br />
          <span className="font-light italic">em Português</span>
        </h1>

        <p className="mt-5 md:mt-7 text-sm md:text-base text-white/85 max-w-xl leading-relaxed drop-shadow-[0_1px_3px_rgba(0,0,0,0.25)]">
          Encontre os melhores produtos da Hoobuy em uma única planilha organizada. Mais de 10.000 produtos selecionados com links atualizados diariamente.
        </p>

        <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center gap-3 md:gap-4">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="px-7 py-3 rounded-full text-sm font-semibold bg-white/15 backdrop-blur-sm border border-white/30 text-white hover:bg-white hover:text-foreground-950 cursor-pointer whitespace-nowrap transition-all duration-300"
          >
            Explorar Hoobuy Sheet
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="px-7 py-3 rounded-full text-sm font-semibold bg-primary-500 text-white hover:bg-primary-600 cursor-pointer whitespace-nowrap transition-all duration-300"
          >
            Buy It Now
          </a>
        </div>

        <div className="mt-10 md:mt-14 flex items-center gap-6 text-white/60 text-xs">
          <span className="flex items-center gap-1.5"><i className="ri-check-line text-accent-400"></i> 10.000+ Produtos</span>
          <span className="flex items-center gap-1.5"><i className="ri-check-line text-accent-400"></i> Links Atualizados</span>
          <span className="flex items-center gap-1.5"><i className="ri-check-line text-accent-400"></i> Inspeção Grátis</span>
        </div>

        <button
          onClick={() => {
            const el = document.getElementById('categorias');
            if (el) el.scrollIntoView({ behavior: 'smooth' });
          }}
          className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/50 hover:text-white/90 cursor-pointer transition-colors animate-bounce"
        >
          <i className="ri-arrow-down-line text-2xl"></i>
        </button>
      </div>
    </section>
  );
}